import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { API_URL, ICategorySummaryDto } from '@/dtos';

import { CategoryItem, CategoryTypeDto } from '../Services.types';

export const QUERY_KEY = 'GET_SERVICE_CATEGORIES_LIST';

const useGetCategoriesQuery = () => {
  const { data, isLoading } = useQuery([QUERY_KEY], () => api.get<ICategorySummaryDto[]>(API_URL.CATEGORIES));

  const categories = useMemo<CategoryItem[]>(() => {
    if (!data?.data) return [];
    return data.data.map((item) => ({
      id: toString(item.id),
      name: (item.name || '') as CategoryTypeDto,
      description: item.description || '',
      serviceCount: item.service_count || 0,
    }));
  }, [data]);

  return { categories, isLoading };
};

export default useGetCategoriesQuery;
